import {
    Box,
    Flex,
    HStack,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay, Text, Textarea, useDisclosure, useMediaQuery, VStack,
} from "@chakra-ui/react";
import {CustomCheckbox, CustomSelectCountries, InputLabel, StyledButton} from "../../index";
import React from "react";
import {useForm} from "react-hook-form";
import {ReactComponent as RightArrow} from "../../../assets/icons/profile/angle-right_neutral.svg";
import {ReactComponent as QuestionIcon} from "../../../assets/icons/question-circle.svg";
import {ReactComponent as ChatQuestion} from "../../../assets/icons/chat-question.svg";
import {ReactComponent as LightIcon} from "../../../assets/icons/lightbulb.svg";
import {ReactComponent as Stepper} from "../../../assets/icons/profile/stepper_frame_order.svg";
import {ReactComponent as Minus} from "../../../assets/icons/minus.svg";
import {ReactComponent as Plus} from "../../../assets/icons/plus.svg";
import {ReactComponent as StepperMobile} from "../../../assets/icons/profile/stepper_frame_order_mobile.svg";
import Select from "react-select";
import {CustomSelectExchanges} from "../../theme/select/CustomSelectExchanges";
import theme from "../../../styles/customTheme";


export const ScreenerFilterModal = ({isOpen, onClose}) => {
    const { isOpen: isOpenBottomPart, onOpen: onOpenBottomPart, onClose: onCloseBottomPart } = useDisclosure();
    const [isMobile] = useMediaQuery("(max-width: 668px)");
    const neutral900 =theme.colors.neutral[900]

    const {
        handleSubmit,
        formState: {errors, isValid}
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            email: '',
            phone: '',
            telegramNic: '',
        }
    })

    const submit = () => {

    }


    return (
        <Modal
            isCentered
            isOpen={isOpen}
            onClose={onClose}>
            <ModalOverlay/>
            <ModalContent
                maxW={'1140px'}
                maxH={'630px'}
                borderColor={'neutral.700'}
                border={'solid 1px'}
                borderRadius={'16px'}
                bg={'dark'}>
                <ModalBody p={'24px'}>
                    <form
                        onSubmit={handleSubmit(submit)}>
                        <VStack gap={'24px'}>
                            <HStack
                                w={'full'}
                                alignItems={'start'}>
                                <Flex
                                    display={'flex'}
                                    flexWrap={'wrap'}
                                    justifyContent={'space-between'}
                                    gap={'24px'}
                                    w={'full'}>
                                    <Flex display={'flex'} justifyContent={'space-between'} w={'full'}>
                                        <Box
                                            display={'flex'}
                                            zIndex={'1111111'}
                                            flexDirection={'column'}
                                            gap={'12px'}
                                            w={'348px'}>
                                            <Text color={'neutral.600'}>Tracked exchanges</Text>
                                            <CustomSelectExchanges
                                                w={'full'}
                                                bg={neutral900}
                                                height={isMobile ? '40px' : '40px'}
                                                exchangeOptions={[
                                                    { value: 'Binance', label: 'Binance' },
                                                    { value: 'Bybit', label: 'Bybit' },
                                                    { value: 'Coinbase', label: 'Coinbase' },
                                                    { value: 'Gate', label: 'Gate' },
                                                    { value: 'HTX', label: 'HTX' },
                                                    { value: 'Mex', label: 'Mex' }
                                                ]}
                                            >
                                            </CustomSelectExchanges>
                                        </Box>
                                        <Box display={'flex'}
                                             flexDirection={'column'}
                                             gap={'12px'}
                                             w={'348px'}>
                                            <Text color={'neutral.600'}>Whitelist of
                                                currencies</Text>
                                            <Textarea
                                                w={'full'}
                                                bg={'neutral.900'}
                                                height={isMobile ? '40px' : '40px'}
                                                minH={isMobile ? '40px' : '40px'}
                                                color={'#fff'}
                                                outline={'0'}
                                                border={'solid 1px #23262F'}
                                                _hover={{
                                                    border:'solid 1px#23262F',
                                            }}
                                            ></Textarea>
                                        </Box>
                                        <Box display={'flex'}
                                             flexDirection={'column'}
                                             gap={'12px'}
                                             w={'348px'}>
                                            <Text color={'neutral.600'}>Blacklist of
                                                currencies</Text>
                                            <InputLabel
                                                w={'full'}
                                                bg={'neutral.900'}
                                                height={isMobile ? '40px' : '40px'}

                                            />
                                        </Box>
                                    </Flex>
                                    <Flex display={'flex'} justifyContent={'space-between'} w={'full'}>
                                        <Box display={'flex'}
                                             flexDirection={'column'}
                                             gap={'12px'}
                                             w={'348px'}>
                                            <Text color={'neutral.600'}>Minimal transaction amount, $</Text>
                                            <InputLabel
                                                type={'number'}
                                                w={'full'}
                                                bg={'neutral.900'}
                                                height={isMobile ? '40px' : '40px'}

                                            />
                                        </Box>
                                        <Box display={'flex'}
                                             flexDirection={'column'}
                                             gap={'12px'}
                                             w={'348px'}>
                                            <Text color={'neutral.600'}>Minimal profit, %</Text>
                                            <InputLabel
                                                type={'number'}
                                                w={'full'}
                                                bg={'neutral.900'}
                                                height={isMobile ? '40px' : '40px'}

                                            />
                                        </Box>
                                        <Box display={'flex'}
                                             flexDirection={'column'}
                                             gap={'12px'}
                                             w={'348px'}
                                        >
                                            <Text color={'neutral.600'}>Maximum profit, %</Text>
                                            <InputLabel
                                                type={'number'}
                                                w={'full'}
                                                bg={'neutral.900'}
                                                height={isMobile ? '40px' : '40px'}

                                            />
                                        </Box>
                                    </Flex>
                                </Flex>
                            </HStack>
                            <VStack>
                                <StyledButton
                                    p={'0'}
                                    maxH={'20px'}
                                    gap={'16px'}
                                    bg={'unset'}
                                    fontSize={'16px'}
                                    textColor={'purple.500'}
                                    shadowHoverColor={'none'}
                                    hoverBg={'unset'}>
                                    <Text>Wide filters</Text>
                                    {isOpenBottomPart ?(
                                        <Minus  onClick={onCloseBottomPart}/>
                                    ):(<Plus  onClick={onOpenBottomPart}/>)}
                                </StyledButton>
                            </VStack>
                            {isOpenBottomPart ? (
                                <HStack
                                    alignItems={'start'}>
                                    <Flex
                                        w={'full'}
                                        display={'flex'}
                                        flexWrap={'wrap'}
                                        justifyContent={'space-between'}
                                        gap={'24px'}>
                                        <Flex display={'flex'} justifyContent={'space-between'} w={'full'}>
                                            <Box
                                                display={'flex'}
                                                zIndex={'11111'}
                                                flexDirection={'column'}
                                                gap={'12px'}
                                                w={'348px'}>
                                                <Text color={'neutral.600'}>Exchanges for buying</Text>
                                                <CustomSelectExchanges
                                                    w={'full'}
                                                    bg={neutral900}
                                                    height={isMobile ? '40px' : '40px'}
                                                    exchangeOptions={[
                                                        { value: 'Binance', label: 'Binance' },
                                                        { value: 'Bybit', label: 'Bybit' },
                                                        { value: 'Coinbase', label: 'Coinbase' },
                                                        { value: 'Gate', label: 'Gate' },
                                                        { value: 'HTX', label: 'HTX' },
                                                        { value: 'Mex', label: 'Mex' }
                                                    ]}
                                                >
                                                </CustomSelectExchanges>
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 zIndex={'11111'}
                                                 gap={'12px'}
                                                 w={'348px'}>
                                                <Text color={'neutral.600'}>Exchanges for selling</Text>
                                                <CustomSelectExchanges
                                                    w={'full'}
                                                    bg={neutral900}
                                                    height={isMobile ? '40px' : '40px'}
                                                    placeholder={''}
                                                    exchangeOptions={[
                                                        { value: 'Binance', label: 'Binance' },
                                                        { value: 'Bybit', label: 'Bybit' },
                                                        { value: 'Coinbase', label: 'Coinbase' },
                                                        { value: 'Gate', label: 'Gate' },
                                                        { value: 'HTX', label: 'HTX' },
                                                        { value: 'Mex', label: 'Mex' }
                                                    ]}
                                                >
                                                </CustomSelectExchanges>
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}>
                                                <Text color={'neutral.600'}>Min lifetime, sec</Text>
                                                <InputLabel
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                        </Flex>
                                        <Flex display={'flex'} justifyContent={'space-between'} w={'full'}>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}>
                                                <Text color={'neutral.600'}>Networks for withdrawal</Text>
                                                <InputLabel
                                                    type={'number'}
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}>
                                                <Text color={'neutral.600'}>Networks for deposit</Text>
                                                <InputLabel
                                                    type={'number'}
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}
                                            >
                                                <Text color={'neutral.600'}>Max lifetime, sec</Text>
                                                <InputLabel
                                                    type={'number'}
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                        </Flex>
                                        <Flex display={'flex'} justifyContent={'space-between'} w={'full'}>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}
                                            >
                                                <Text color={'neutral.600'}>Withdrawal network status</Text>
                                                <InputLabel
                                                    type={'number'}
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'12px'}
                                                 w={'348px'}
                                            >
                                                <Text color={'neutral.600'}>Deposit network status</Text>
                                                <InputLabel
                                                    type={'number'}
                                                    w={'full'}
                                                    bg={'neutral.900'}
                                                    height={isMobile ? '40px' : '40px'}

                                                />
                                            </Box>
                                            <Box display={'flex'}
                                                 flexDirection={'column'}
                                                 gap={'30px'}
                                                 w={'348px'}
                                            >
                                                <Text color={'neutral.600'}></Text>
                                                <Flex
                                                    alignItems={'center'}
                                                    gap={'8px'}
                                                >
                                                    <CustomCheckbox
                                                        border={'6px'}
                                                    />
                                                    <Text color={'neutral.100'}>Network Compatibility</Text>
                                                </Flex>
                                            </Box>
                                        </Flex>
                                    </Flex>
                                </HStack>
                            ):('')}
                            <Flex
                                gap={'16px'}
                            >
                                <StyledButton
                                    fontSize={'body.sm'}
                                    fontWeight={'400'}
                                    bg={'#6F41D240'}
                                >Reset</StyledButton>
                                <StyledButton
                                    w={'min-content'}
                                    fontSize={'body.md'}
                                >Save filters to template</StyledButton>
                            </Flex>
                        </VStack>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}